module.exports = __webpack_public_path__ + "img/amsa-sprite.feca9f52.gif";